import { ROUTE_ROOT_PAGES_LIST } from '@/constants/routes';
import { useRemoveRootPageMutation } from '@/queries/rootPages.queries';
import IRootPage from '@/types/IRootPage';
import { useDisclosure } from '@chakra-ui/react';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import { toast } from 'react-toastify';

interface IProps {
	rootPage: IRootPage;
	isLoading: boolean;
	onChange: (e: IRootPage) => void;
	errors?: Record<string, string>;
}

export function useRootPagesDetailsSuccess(props: IProps) {
	const { isOpen, onOpen, onClose } = useDisclosure();
	const { t } = useTranslation();
	const removeRootPageMutation = useRemoveRootPageMutation();
	const history = useHistory();
	const form = useForm<IRootPage>({
		defaultValues: props.rootPage,
	});
	const publicUrl = window.location.origin + '/rp/' + form.getValues('slug');

	const submitForm = form.handleSubmit((e) => {
		props.onChange(e);
	});

	function handleDeleteRootPage() {
		return removeRootPageMutation
			.mutateAsync({ id: props.rootPage.id })
			.then(() => {
				history.push(ROUTE_ROOT_PAGES_LIST);
				toast.success('Link group deleted.');
			})
			.catch(() => {
				toast.success('An error ocurred, try again later.');
			});
	}

	function copyPublicUrl() {
		navigator.clipboard.writeText(publicUrl);
		toast.success('Link copied.');
	}

	return {
		form,
		isOpen,
		publicUrl,
		t,
		copyPublicUrl,
		handleDeleteRootPage,
		onClose,
		onOpen,
		submitForm,
	};
}
